export default __webpack_public_path__ + "static/media/flag-es-MX.d3090e4e.png";